<script setup lang="ts">
import { UiText, UiChip, UiLinkField } from "@shopexperts/shared";

interface KeyedRow {
  key: string;
  label: string;
  value: string;
}

withDefaults(
  defineProps<{
    details: KeyedRow[];
    copyableIdentifiers?: KeyedRow[];
    metadata?: { key: string; value: string }[];
  }>(),
  {
    copyableIdentifiers: () => [],
    metadata: () => [],
  },
);
</script>

<template>
  <section class="flex flex-col gap-4 border-t border-se-gray-200 bg-se-gray-50/60 px-4 py-4">
    <UiText as="h4" variant="p-small" text="Admin details" class="font-semibold text-se-dark" />

    <dl class="grid grid-cols-1 gap-x-8 gap-y-2.5 sm:grid-cols-2">
      <div
        v-for="row in details"
        :key="row.key"
        class="flex items-baseline justify-between gap-3 border-b border-dashed border-se-gray-200 pb-2.5"
      >
        <dt class="shrink-0">
          <UiText as="span" variant="small" :text="row.label" class="text-se-gray-500" />
        </dt>
        <dd class="min-w-0 truncate text-right">
          <UiText as="span" variant="small" :text="row.value" class="font-medium text-se-dark" />
        </dd>
      </div>
    </dl>

    <div v-if="copyableIdentifiers.length" class="flex flex-col gap-3">
      <UiLinkField
        v-for="identifier in copyableIdentifiers"
        :key="identifier.key"
        :label="identifier.label"
        :value="identifier.value"
      />
    </div>

    <div v-if="metadata.length" class="flex flex-col gap-1.5">
      <UiText as="span" variant="small" text="Metadata" class="text-se-gray-500" />
      <div class="flex flex-wrap gap-1.5">
        <UiChip
          v-for="entry in metadata"
          :key="entry.key"
          :text="`${entry.key}: ${entry.value}`"
          variant="plain"
          size="xs"
          rounded="small"
        />
      </div>
    </div>
  </section>
</template>
